export const COLOR_REF_MODES = [
	'foregroundColor',
	'backgroundColor',
	'accentForegroundColor',
	'accentBackgroundColor',
] as const
export type ColorRefMode = typeof COLOR_REF_MODES[number]

export const COLOR_REF_FULL_LABELS: Record<ColorRefMode, string> = {
	foregroundColor: 'Foreground',
	backgroundColor: 'Background',
	accentForegroundColor: 'Accent foreground',
	accentBackgroundColor: 'Accent background',
}

export function ColorDot({ color }: { color?: string }) {
	if (!color) {
		return (
			<div className="size-3 rounded-full border border-grey-200 relative overflow-hidden shrink-0">
				<div className="absolute inset-0 bg-white" />
				<div className="absolute inset-0 flex items-center justify-center">
					<div className="h-px w-[130%] rotate-45 bg-red-400" />
				</div>
			</div>
		)
	}
	return (
		<div
			className="size-3 rounded-full shadow-[inset_0_0_0_1px_rgba(0,0,0,0.1)] shrink-0"
			style={{ backgroundColor: color }}
		/>
	)
}
